import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import * as fromFirmware from './';
import { AddFirmwaresDialogComponent } from './dialogs/add-firmwares-dialog/add-firmwares-dialog.component';
import { FirmwaresComponent } from './firmwares.component';
import { FirmwareEffects } from './firmwares.effects';
import { DisplayRouterTypePipe } from './display-router-type.pipe';

@NgModule({
    imports: [
        SharedModule,
        StoreModule.forFeature(fromFirmware.firmwareFeatureKey, fromFirmware.firmwares),
        EffectsModule.forFeature([FirmwareEffects]),
    ],
    exports: [FirmwaresComponent],
    declarations: [FirmwaresComponent, AddFirmwaresDialogComponent, DisplayRouterTypePipe],
    providers: [DisplayRouterTypePipe],
})
export class FirmwaresModule {}
